export default __webpack_public_path__ + "static/media/writing.ae6afb38.png";